import { createFileRoute, notFound } from "@tanstack/react-router";
import { BlogArticleTemplate } from "@/components/blog/BlogArticleTemplate";
import { getBlogPost } from "@/content/blog";

export const Route = createFileRoute("/blog/$slug")({
  loader: ({ params }) => {
    const post = getBlogPost(params.slug);
    if (!post) throw notFound();
    return post;
  },
  head: ({ loaderData }) => {
    if (!loaderData) return { meta: [] };

    const url = `https://fotopasion.es/blog/${loaderData.slug}`;
    const image = loaderData.featuredImage.startsWith("http")
      ? loaderData.featuredImage
      : `https://fotopasion.es${loaderData.featuredImage}`;

    return {
      meta: [
        { title: `${loaderData.title} · FotoPasión` },
        { name: "description", content: loaderData.description },
        { property: "og:title", content: loaderData.title },
        { property: "og:description", content: loaderData.description },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { property: "og:image", content: image },
        { property: "og:image:alt", content: loaderData.featuredImageAlt },
        { property: "article:published_time", content: loaderData.publishedAt },
        { property: "article:author", content: loaderData.author },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: loaderData.title },
        { name: "twitter:description", content: loaderData.description },
        { name: "twitter:image", content: image },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: BlogArticle,
});

function BlogArticle() {
  const post = Route.useLoaderData();
  return <BlogArticleTemplate post={post} />;
}
